export const createDice = (
  x: number,
  y: number,
  scene: Phaser.Scene,
  duration = 2000,
  sizeInPx = 128,
  mask?: Phaser.Display.Masks.GeometryMask,
) => {
  let diceIsRolling = false;

  const dice = scene.add.mesh(x, y, 'dice');
  if (mask) dice.setMask(mask);
  dice.addVerticesFromObj('dice-obj', 0.25);

  // 1. panZ(6) moves the dice away, which affects its screen-space size.
  // 2. We calculate a multiplier that accounts for the screen scale.
  // In Phaser Meshes, a scale of 1 usually fills a portion of the view.
  // We use the viewport height to normalize the size.
  const scaleMultiplier = (sizeInPx / scene.scale.height) * 2.5;
  dice.setScale(scaleMultiplier);
  dice.scale = scaleMultiplier;

  dice.panZ(6);

  dice.modelRotation.x = Phaser.Math.DegToRad(0);
  dice.modelRotation.y = Phaser.Math.DegToRad(-90);

  const roll = (diceRoll: number, callback: (roll: number) => void) => {
    if (!Number.isInteger(diceRoll) || diceRoll < 1 || diceRoll > 6) {
      throw new Error(`Invalid diceRoll: ${diceRoll}`);
    }

    if (diceIsRolling) {
      throw new Error('Dice is already rolling');
    }

    diceIsRolling = true;

    scene.add.tween({
      targets: dice,
      from: 0,
      to: 1,
      duration: duration,
      onUpdate: () => {
        // rotation speed
        dice.modelRotation.x -= 0.035;
        dice.modelRotation.y -= 0.14;
      },
      onComplete: () => {
        switch (diceRoll) {
          case 1:
            dice.modelRotation.x = Phaser.Math.DegToRad(0);
            dice.modelRotation.y = Phaser.Math.DegToRad(-90);
            break;
          case 2:
            dice.modelRotation.x = Phaser.Math.DegToRad(90);
            dice.modelRotation.y = Phaser.Math.DegToRad(0);
            break;
          case 3:
            dice.modelRotation.x = Phaser.Math.DegToRad(180);
            dice.modelRotation.y = Phaser.Math.DegToRad(0);
            break;
          case 4:
            dice.modelRotation.x = Phaser.Math.DegToRad(180);
            dice.modelRotation.y = Phaser.Math.DegToRad(180);
            break;
          case 5:
            dice.modelRotation.x = Phaser.Math.DegToRad(-90);
            dice.modelRotation.y = Phaser.Math.DegToRad(0);
            break;
          case 6:
            dice.modelRotation.x = Phaser.Math.DegToRad(90);
            dice.modelRotation.y = Phaser.Math.DegToRad(90);
            break;
        }
      },
      ease: 'Quart.easeOut',
    });

    // Scale pulse
    scene.add.tween({
      targets: dice,
      scale: scaleMultiplier * 1.2,
      duration: duration - 200,
      yoyo: true,
      ease: Phaser.Math.Easing.Quadratic.InOut,
      onComplete: () => {
        dice.scale = scaleMultiplier;
        diceIsRolling = false;
        callback(diceRoll);
      },
    });
  };

  return {
    roll,
    dice,
  };
};
